import { CommandType } from "~app/common/services/cqs/CommandType";
import { AvverkningsanmalanCommandBase } from "./AvverkningsanmalanCommandBase";

export class UpdateAvverkningsanmalanRaskStatusCommand extends AvverkningsanmalanCommandBase {
    raskStatus: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateAvverkningsanmalanRaskStatusCommand";

    constructor(kontraktGuid: string, atgardGuid: string, raskStatus: number) {
        super(kontraktGuid, atgardGuid, UpdateAvverkningsanmalanRaskStatusCommand.$type, CommandType.Replace);
        this.raskStatus = raskStatus;
    }
}
